import React from 'react';
import './FleetManager.css';

import { withTranslation } from 'react-i18next/hooks';

import { getLang } from '../functions/lang'
import { isString } from 'util';

import * as dev from '../api/dev'

import { ServerApi } from './api/ServerApi';

import { Container } from '@material-ui/core';

import {ConnectionProgress} from '../pages/ConnectionProgress';
import { Login } from '../pages/Login';
import { ServerManager } from './pages/ServerManager'
import { base64toGuid, getBase64ID, getObjectByID } from '../api/helpers';
import { ConfirmDialog } from '../components/ConfirmDialog';
import { AlertDialog } from '../components/AlertDialog';
import i18n from '../i18n';

//import { FLEET_STATISTICS_FUNCTION_OVERVIEW, FLEET_STATISTICS_FUNCTION_NETWORKS, 
//    FLEET_STATISTICS_FUNCTION_DMR_NETWORKS, FLEET_STATISTICS_FUNCTION_SERVER } from './api/ServerApi'
//import { TrackChangesOutlined } from '@material-ui/icons';


//export default 
class FleetManager_ extends React.Component {


    constructor(props) {
        super(props);

        //const {t} = props 

        let login = localStorage.getItem('login');
        let password = sessionStorage.getItem('password');
        let serveraddress = localStorage.getItem('serveraddress')
        if(!serveraddress) serveraddress = window.location.host

        this.state = {
            isLogged: false,
            isConnecting: false, //this.isConnecting(),
            authUser: {
                login: isString(login) ? login : '',
                password: isString(password) ? password : '',
                serveraddress: isString(serveraddress) ? serveraddress : ''
            },
            networkEditor: {
                networkID: '',
                networkData: null,
                networkSettings: null
            },
            serverSettingsEditor:{
                open: false,
                serverSettings: null
            },
            serverSettings: null,
            newNetworkSettings: null,
            apiError: false,
            apiMessage: '',
            page: 'login',
            networks: [],
            confirmDialog: {open: false, message:''},
            alertDialog: {open: false, message:''},
            licenses: []
        }

        this.api = null

        this.handleAppAction = this.handleAppAction.bind(this)
        this.handleNetworksChanged = this.handleNetworksChanged.bind(this)
        this.handleNewNetworkSettings = this.handleNewNetworkSettings.bind(this)
    }

    componentDidMount(){
        this.setTitle()
    }
    componentDidUpdate(){
        this.setTitle()
    }
    setTitle(){
        document.title = this.props.config.title + ' Server Manager'
    }

    componentWillUnmount(){
        this.stopApi()
    }

    /*
    getLang(i18n) {
        let lang = this.props.i18n.language
        if (lang.indexOf('-')) {
            lang = lang.split('-')[0]
        }
        let { langs } = this.props.i18n.options
        let defaultLang = null
        let existLang = null
        for (let key in langs) {
            if (key === lang) {
                existLang = key
                break
            }
            if (langs[key].default === true) {
                defaultLang = key
            }
        }

        if (!existLang) {
            lang = defaultLang
            this.props.i18n.changeLanguage(lang)
        }

        return lang
    }
    */

    login(login, password, serveraddress) {
        console.log('login()')
        if (login) {
            localStorage.setItem("login", login);
            sessionStorage.setItem("password", password);
            localStorage.setItem("serveraddress", serveraddress);

            this.setState({ isConnecting: true, page: 'connecting' });
            this.startApi(serveraddress, login, password, this.props.config);

            //this.eventLogger.setDispatcher(login)
            //this.eventLogger.add({ type: EVENT_TYPE.TYPE_LOGIN, sender: login, note: '' })
        }
    }

    startApi(serveraddress, login, password, config) {
        
        let options = {
            //settings: this.settings,
            //eventLogger: this.eventLogger,
            //fileStorage: this.fileStorage,
            onError: this.handleApiError.bind(this),
            onClose: this.handleApiClose.bind(this),
            onConnect: this.handleApiConnect.bind(this),
            onAction: this.handleAppAction.bind(this),
            config: config,
            onNetworksChanged: this.handleNetworksChanged.bind(this),
            //onAvatarUpdate: this.handleAvatarUpdate.bind(this),
            //onPttCall: this.handlePttCall.bind(this),
            //onUnreadMessagesChanged: this.handleUnreadMessagesChanged.bind(this),
            //onEmergency: this.handleEmergency.bind(this)
        }
        console.log('start api; server='+serveraddress)
        this.api = new ServerApi(serveraddress, login, password, options)
        this.api.connect();
    }

    stopApi(){
        if(this.api){
            this.api.close()
            this.api = null
        }
    }


    //login form callback
    handleLogin(login, password, serveraddress) {
        this.setState({
            authUser: {
                login: login,
                password: password,
                serveraddress: serveraddress
            }
        })
        this.login(login, password, serveraddress);
    }

    handleApiError(err, connectCount) {
        console.log('handleApiError error')
        console.log(err)
        if (isString(err)) {
            this.setState({ apiError: true, apiMessage: err })
        } else {
            if (err.type === 'login') {
                this.setState({ apiError: true, apiMessage: err.message, page: 'login', isConnecting: true })
            } else {
                let errorStr = JSON.stringify(err, ["message", "arguments", "type", "name"]);
                this.setState({ apiError: true, apiMessage: 'An error occured: ' + errorStr + ' ' + connectCount })
                console.log(err)
            }
        }
    }

    handleApiClose(evt, connectCount) {
        //console.log(evt)
        switch (evt.code) {
            case 1006:
                this.setState({ apiError: true, apiMessage: 'Try to Connect: ' + connectCount })
                break;
            case 1005:
                //No Status Received - regular close connection
                if (this.state.page !== 'login') {
                    this.setState({ 
                        apiError: true, 
                        apiMessage: 'Try to Connect: ' + connectCount,
                        isConnecting: true
                    })
                }
                break;

            default:
                this.setState({ 
                    apiError: true, 
                    apiMessage: 'handleApiClose:' + evt.code + '; ' + JSON.stringify(evt) 
                })
        }
    }

    //on message CONFIG_SERVER_RESPONSE_ACK
    handleApiConnect() {
        this.setState({ 
            isLogged: true, 
            isConnecting: false, 
            page: '',
            apiError: false, 
            apiMessage: ''
        })


        this.api.queryGetServerSettings((serverSettings) => {
            //if (this.state.networkEditor) {
                console.log('handleApiConnect queryGetServerSettings')
                console.log(serverSettings)
                this.setState({serverSettings: serverSettings})
            //}
        })
    }

    handleNetworksChanged(nets) {
        this.setState({ networks: nets })
    }

    handleNewNetworkSettings(networkSettings){
        this.setState({newNetworkDialog: {
            open: true,
            settings: networkSettings
        } })
    }
           

    handleAppAction(action) {

        const {t} = this.props

        //console.log('App.action')
        //console.log(action)
        switch (action.type) {

            case 'SET_LANGUAGE':
                const lang = action.lang;
                this.props.i18n.changeLanguage(lang);
                break;

            case 'LOGOUT':
                this.setState({
                    isLogged: false,
                    isConnecting: false,
                    page: 'login',
                    apiError: false,
                    apiMessage: '',
                    networkEditor: {
                        networkID: '',
                        networkData: null,
                        networkSettings: null
                    },
                    serverSettingsEditor:{
                        open: false,
                        serverSettings: null
                    },
                })
                this.api.close();
                break;

            case 'NETWORK_EDITOR_SHOW':
                //console.log('action')    
                //console.log(action)
                //alert('NETWORK_EDITOR_SHOW ' + action.networkID);
                //debugger;
                const network = getObjectByID(action.networkID, this.state.networks)
                this.setState({
                    page: 'networkeditor',
                    networkEditor: { 
                        networkID: action.networkID, 
                        networkData: {...network},
                        networkSettings: null,
                        serverSettings: null
                    }
                });
                this.api.queryGetNetworkSettings(action.networkID, (networkSettings) => {
                    if (this.state.networkEditor && this.state.networkEditor.networkID) {

                        console.log('networkData')
                        console.log(network)
                        console.log('networkSettings')
                        console.log(networkSettings)

                        const networkEditor = {
                            ...this.state.networkEditor, 
                            networkID: action.networkID,
                            networkData: {...network},
                            networkSettings: networkSettings 
                        }
                        this.setState({networkEditor: networkEditor})
                    }
                })

                this.api.queryGetServerSettings((serverSettings) => {
                    if (this.state.networkEditor) {
                        console.log('setState networkEditor')
                        console.log(serverSettings)
                        const networkEditor = {
                            ...this.state.networkEditor, 
                            serverSettings:serverSettings
                        }
                        this.setState({networkEditor: networkEditor})
                    }
                })

                break;

            case 'NETWORK_EDITOR_SAVE':
                this.api.querySaveNetworkSettings(action.networkData, action.networkSettings);
                this.setState({ networkEditor: null, page: '' })
                break;

            case 'NETWORK_EDITOR_CLOSE':
                this.setState({ networkEditor: null, page: '' })
                break;

            case 'NETWORK_EDITOR_ADD':{
                let networkID = getBase64ID()
                this.api.addNetwork(networkID, this.handleNewNetworkSettings)
                break;
            }

            case 'NEW_NETWORK_DIALOG_CLOSE':
                this.setState({newNetworkDialog: null })
                break

            case 'NEW_NETWORK_CREATE':{
                let {settings, callback} = action
                //this.setState({newNetworkDialog: null })

                this.api.createNetwork(settings, callback)
                break
            }

            case 'NETWORK_DELETE':{
                let {networkID} = action
                this.api.deleteNetwork(networkID)
                break
            }

            case "START_NETWORK":{
                this.api.startNetwork(action.networkID);
                break;
            }

            case "STOP_NETWORK":{
                this.api.stopNetwork(action.networkID);
                break;
            }

            case 'GET_LICENSES':{
                //console.log('GET_LICENSES')
                this.api.queryLicenses(action.callback)
                break
            }

            case 'SET_LICENSES':{
                console.log('SET_LICENSES')
                console.log(action.licenses)
                this.setState({licenses: action.licenses})
                break
            }

            case 'LICENSES_EDITOR_SHOW':{

                //this.api.queryLicenses()

                this.setState({
                    page: 'licensesEditor',
                    licensesEditor: {
                        open: true
                    }
                });
                break
            }

            case 'LICENSES_EDITOR_CLOSE':{
                this.setState({
                    page: 'licensesEditor',
                    licensesEditor: {
                        open: false
                    }
                });
                break
            }


            case "SERVER_SETTINGS_EDITOR_SHOW":{
                this.setState({
                    page: 'server_settings',
                    serverSettingsEditor: { open: true, serverSettings: null }
                });
                this.api.queryGetServerSettings((serverSettings) => {
                    if (this.state.serverSettingsEditor) {
                        console.log('setState serverSettingsEditor')
                        console.log(serverSettings)
                        this.setState({
                            serverSettingsEditor: {
                                open: true,
                                serverSettings: serverSettings
                            }
                        })
                    }
                })  
                //todo query server settings

                break
            }

            case 'SERVER_SETTINGS_EDITOR_CLOSE':{
                this.setState({page: '', serverSettingsEditor:  {open: false, serverSettings: null} });
                break
            }

            case 'SERVER_SETTINGS_EDITOR_SAVE':{
                let {serverSettings} = action
   
                if(serverSettings.ServerData.WebLocale !== i18n.language){
                    i18n.changeLanguage(serverSettings.ServerData.WebLocale);
                }

                this.api.querySaveServerSettings(serverSettings)
                this.setState({page: '', serverSettingsEditor:  {open: false, serverSettings: null} });
                break
            }

            case 'CONFIRM_DIALOG':{
                this.setState({confirmDialog:{
                    open: true, 
                    message: action.message, 
                    title: action.title ? action.title : t('ServerManager'),
                    onConfirm: action.onConfirm ? action.onConfirm : null
                }})
                break
            }

            case 'CONFIRM_DIALOG_CLOSE':{
                this.setState({confirmDialog:{open: false, message: '', title: ''}})
                break
            }

            case 'ALERT_DIALOG':{
                this.setState({alertDialog:{
                    open: true, 
                    message: action.message, 
                    title: action.title ? action.title : t('ServerManager'),
                    onConfirm: action.onConfirm ? action.onConfirm : null
                }})
                break
            }
            
            case 'ALERT_DIALOG_CLOSE':{
                this.setState({alertDialog:{open: false, message: '', title: ''}})
                break
            }


            case 'LICENSE_CHECK':{
                /*
                let licenses = {
                    AisDmr: 1,
                    CalttaDmr: 0,
                    Client: 10,
                    Dispatcher: 2,
                    Ermak: 0,
                    HyteraDmr: 0,
                    HyteraXpt: 0,
                    KirisunDmr: 0,
                    Sip: 1,
                    IndoorTracking: 1,
                    Monitoring: 1,
                    Encryption: 1
                }
                */
                
                
                //console.log(this.state.serverSettings.ServerData.Licenses)
                let licenses = this.state.serverSettings.ServerData.Licenses
                //console.log('LICENSE_CHECK ' +action.licenseName)
                //console.log(licenses)
                //console.log(action.licenseName+'='+licenses[action.licenseName])
                return licenses[action.licenseName]
                //break
            }

            case 'GET_VERSION':{
                return this.api.getVersion();
                break;
            }


            default: dev.alert('App action [' + action.type + '] not defined')

        }

    }


    render() {

        //const { t, i18n } = this.props;
        //console.log('this.state')
        //console.log(this.state)

        if (this.state.isConnecting) {
            return (
                <ConnectionProgress apiError={this.state.apiError} 
                        apiMessage={this.state.apiMessage} 
                        onAction={this.handleAppAction} />
            )
        } else if (this.state.page === 'login'){
            return (
                <Container height="100vh" style={{ paddingTop: '2em' }}>
                    <Login onLogin={this.handleLogin.bind(this)}
                        login={this.state.authUser.login}
                        password={this.state.authUser.password}
                        serveraddress={this.state.authUser.serveraddress}
                        lang={getLang(this.props.i18n)}
                    />
                </Container>
            );
        } else {

            let confirmDialog = this.state.confirmDialog && this.state.confirmDialog.open ? (
                <ConfirmDialog {...this.state.confirmDialog} onAction={this.handleAppAction}></ConfirmDialog>
            ):''

            let alertDialog = this.state.alertDialog && this.state.alertDialog.open ? (
                <AlertDialog {...this.state.alertDialog} onAction={this.handleAppAction}></AlertDialog>
            ):''
            
            return(
                <>
                {confirmDialog}
                {alertDialog}
                <ServerManager
                        user={this.state.authUser}
                        onAction={this.handleAppAction}
                        statusError={this.state.apiError}
                        statusMessage={this.state.apiMessage}

                        networks={this.state.networks}
                        licenses={this.state.licenses}

                        networkEditor={this.state.networkEditor}

                        licensesEditor={this.state.licensesEditor}

                        newNetworkDialog={this.state.newNetworkDialog}

                        serverSettingsEditor={this.state.serverSettingsEditor}
  
                        //statisticsOverview={this.state.statisticsOverview}
                        //statisticsNetworks={this.state.statisticsNetworks}
                        //statisticsDmr={this.state.statisticsDmr}
                        //statisticsServer={this.state.statisticsServer}
                    />
                </>
            )
        }
    }

}


export const FleetManager = withTranslation()(FleetManager_);